export default __webpack_public_path__ + "static/media/Club of the Wolf Rider.8bf25f6c.jpg";